import { head } from 'lodash/fp';
import { useQuery } from '@apollo/client/react';

import { GET_EXPLAINED_TERM } from '../../queries/get-explained-term/query.gql';
import uniqueContentWithDraftPrecedence from '../../../../../cms/utils/unique-content-with-draft-precedence';

type UseGetExplainedTerm = {
  skip?: boolean;
  slug: string;
};

const useGetExplainedTerm = ({ skip = false, slug }: UseGetExplainedTerm) => {
  const { data, loading, error } = useQuery(GET_EXPLAINED_TERM, {
    skip,
    variables: { slug },
  });

  return {
    error,
    explainedTerm: head(uniqueContentWithDraftPrecedence(data?.allExplainedTerm)),
    hasErrors: Boolean(error),
    isLoading: skip || loading,
  };
};

export default useGetExplainedTerm;
